import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    text: 'Descarga el manual y lee el protocolo de 10 minutos en menos de una hora.'
  }, {
    num: '02',
    text: 'Aplica el "Aterrizaje Suave" la próxima vez que recojas a tus hijos.'
  }, {
    num: '03',
    text: 'Observa cómo la tensión desaparece y la conversación fluye sin que tengas que pedirlo.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-cream" data-id="element-92">
      <div className="max-w-2xl mx-auto" data-id="element-93">
        <FadeIn data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-95">
            Cómo funciona
          </h2>
          <div className="space-y-8" data-id="element-96">
            {steps.map((step, idx) => <div key={idx} className="flex items-start gap-6" data-id="element-97">
                <div className="text-4xl font-serif font-bold text-brand-amber opacity-50" data-id="element-98">
                  {step.num}
                </div>
                <p className="text-xl leading-relaxed pt-2 font-medium" data-id="element-99">
                  {step.text}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}